export default __webpack_public_path__ + "static/media/agra.50849407.jpg";